module.exports = __webpack_public_path__ + "img/class8.9395fdd0.webp";